import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import { store } from "../store";
import { login } from "../features/auth/Auth";
import { toast } from "react-toastify";
import { useGoogleLogin } from "@react-oauth/google";
import api from "../api/api";
import { encrypt } from "../utils/CryptData";
import { logoMoide, googleLogo } from "../assets/images";

const urlGoogle = "https://www.googleapis.com/oauth2/v3/userinfo?access_token";

const Login = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [checkPwd, setCheckPawd] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const navigate = useNavigate();

  const handleCheck = () => {
    setCheckPawd(!checkPwd);
  };

  const isValidate = () => {
    let isProceed = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (formData.email.length === 0) {
      isProceed = false;
      toast.error("Veuillez entrer votre adresse e-mail");
    } else if (!emailRegex.test(formData.email)) {
      isProceed = false;
      toast.error("Veuillez entrer une adresse e-mail valide");
    } else if (formData.password.length === 0) {
      isProceed = false;
      toast.error("Veuillez entrer votre mot de passe");
    } else if (formData.password.length < 6) {
      isProceed = false;
      toast.error("Votre mot de passe doit contenir au minimum 6 caractères");
    }
    return isProceed;
  };



  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      setIsGoogleLoading(true);
      try {
        const { data } = await api.get(`${urlGoogle}=${codeResponse.access_token}`, {
          headers: {
            Authorization: `Bearer ${codeResponse.access_token}`,
            Accept: "application/json",
          },
        });

        const response = await api.post("/auths/login", {
          email: data.email.trim(),
        });

        localStorage.setItem("dus", encrypt(JSON.stringify(response.data)));
        store.dispatch(login());
        navigate("/");
        toast.success("Vous êtes connecté");
      } catch (error) {
        toast.error(error.response?.data?.message ?? "Erreur lors de la connexion avec Google");
      } finally {
        setIsGoogleLoading(false);
      }
    },
    onError: () => {
      toast.error("Erreur lors de la connexion avec Google");
      setIsGoogleLoading(false);
    },
  });

  // const handleFacebookLogin = () => {
  //   // Add Facebook login logic here
  //   toast.info("Facebook login not implemented yet.");
  // };

  // const responseFacebook = async (response) => {
  //   // Add Facebook login logic here
  //   console.log(response)
  //   await getDataUserFaceBook(response)
  // };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (isValidate()) {
      setIsLoading(true);
      try {
        const response = await api.post("/auths/login", {
          email: formData.email.trim(),
          password: formData.password.trim(),
        });

        localStorage.setItem("dus", encrypt(JSON.stringify(response.data)));
        store.dispatch(login());
        toast.success("Vous êtes connecté");
        navigate("/");
      } catch (err) {
        toast.error("Email ou mot de passe incorrect");
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-offset="200"
      className=" grid grid-cols-1 md:grid-cols-2 gap-6 items-center"
    >
      {/* Form Section */}
      <div className="flex flex-col min-h-screen items-center justify-center px-4 sm:px-6 lg:px-8 bg-white">
        <div className="w-full max-w-md  p-8 ">
          <h2 className="text-center text-3xl font-bold text-gray-900 mb-2">
            Connectez-vous
          </h2>
          <p className="text-center text-gray-600 mb-8 text-sm">
            Accédez à votre compte pour continuer
          </p>

          <form className="space-y-5" onSubmit={onSubmit}>
            {/* Email Field */}
            <label className="form-control w-full">
              <div className="label">
                <span className="label-text font-semibold text-gray-700">Email</span>
              </div>
              <div className="flex items-center gap-2 input input-bordered w-full focus-within:border-indigo-500 focus-within:ring-1 focus-within:ring-indigo-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  className="w-4 h-4 opacity-70 text-gray-500"
                >
                  <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z" />
                  <path d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z" />
                </svg>
                <input
                  type="email"
                  placeholder="exemple@email.com"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  className="grow placeholder:text-gray-400 sm:text-sm outline-none"
                  required
                />
              </div>
            </label>

            {/* Password Field */}
            <label className="form-control w-full">
              <div className="label">
                <span className="label-text font-semibold text-gray-700">Mot de passe</span>
              </div>
              <div className="flex items-center gap-2 input input-bordered w-full focus-within:border-indigo-500 focus-within:ring-1 focus-within:ring-indigo-500">
                <input
                  type={checkPwd ? "text" : "password"}
                  placeholder="Min. 6 caractères"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                  className="grow placeholder:text-gray-400 sm:text-sm outline-none"
                  required
                />
                <button
                  type="button"
                  onClick={handleCheck}
                  aria-label="Toggle password visibility"
                  className="text-lg hover:opacity-70 transition"
                >
                  {checkPwd ? "🙈" : "👁️"}
                </button>
              </div>
            </label>

            {/* Forgot Password */}
            <div className="text-sm text-end">
              <Link to="/email_reset" className="text-primary hover:text-primary/90 font-medium transition">
                Mot de passe oublié?
              </Link>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isLoading || isGoogleLoading}
              className="w-full rounded-md bg-primary p-3 text-white font-semibold hover:bg-primary/90 transition duration-200 mt-6 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {isLoading && (
                <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
              )}
              {isLoading ? "Connexion en cours..." : "Se connecter"}
            </button>

            {/* Alternative Login */}
            <div className="relative my-6">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-gray-600">ou connectez-vous avec</span>
              </div>
            </div>

            <button
              type="button"
              disabled={isLoading || isGoogleLoading}
              className="w-full flex items-center justify-center gap-3 p-3 rounded-md border-2 border-gray-300 hover:bg-gray-50 transition font-medium text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={handleGoogleLogin}
            >
              {isGoogleLoading ? (
                <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
              ) :null}
              {isGoogleLoading ? "Connexion..." : <img src={googleLogo} alt="Google Logo" className="w-50 h-8" />}
            </button>

            {/* Signup Link */}
            <p className="text-sm text-center mt-6">
              Je n'ai pas de compte?{" "}
              <Link to="/sign_up" className="text-primary hover:text-primary/90 font-semibold transition">
                Créer ici
              </Link>
            </p>
          </form>
        </div>
      </div>

      {/* Image Section (Hidden on Small Screens) */}
      <div className="hidden md:flex justify-center items-center">
        <img
          className="mx-auto w-9/12 h-auto"
          src={logoMoide}
          alt="Moide Ferme"
        />
      </div>
    </div>
  );
};

export default Login;
